import { Drawer, ButtonToolbar, Button, Placeholder, Nav, Sidenav } from 'rsuite';
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import GroupIcon from '@rsuite/icons/legacy/Group';
import MagicIcon from '@rsuite/icons/legacy/Magic';
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import PeopleBranchIcon from '@rsuite/icons/PeopleBranch';
import MemberIcon from '@rsuite/icons/Member';
import TrendIcon from '@rsuite/icons/Trend';
import CreditCardPlusIcon from '@rsuite/icons/CreditCardPlus';
import PeoplesUploadedIcon from '@rsuite/icons/PeoplesUploaded';
import { useNavigate, useLocation } from 'react-router-dom';
import './Drawer.css'
import { useDispatch, useSelector } from "react-redux";


export default function MobileDrawer({ activekey = [] }) {
    const nav = useNavigate()
    const location = useLocation();
    const currentPath = location.pathname;

    const userx = useSelector(state => state.user);

    const dispatch = useDispatch();
    const [active, setActive] = useState(activekey)
    const [open, setOpen] = useState(false);
    const [affliate, setAffliate] = useState({});
    const StoreUser = useSelector((state) => state.user);
    const [affliateAddPermission, setAddAffliatePermisssion] = useState(false);
    const [commissionGroupPermission, setCommmissionGroupPermission] = useState(false);
    const [affliateGroupPermission, setAffliateGroupPermission] = useState(false);
    const [affliateReviewPermission, setAfffliateReviewPermisssion] = useState(false);
    const [userCreatePermisssion, setUserCreatePermisssion] = useState(false);
    const [createCompaignPermission, setCreatCompaignPermission] = useState(false);
    const [mediaAddPermisssion, setMediaAddPermission] = useState(false);
    const [createCreatAffliateGroupPermisssion, setCreatAffliateGroupPermisssion] = useState(false)
    const [createCommissionGroupPermission, setCreatCommissionGroupPermisssion] = useState(false)
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    useEffect(() => {
        setAddAffliatePermisssion(checkPermission(affliate, "aff_add_affiliate"));
        setAfffliateReviewPermisssion(checkPermission(affliate, "aff_affiliate_review"));
        setUserCreatePermisssion(checkPermission(affliate, "set_add_user"));
        setCreatCompaignPermission(checkPermission(affliate, "mkt_create_campaign"))
        setMediaAddPermission(checkPermission(affliate, "mkt_create_media"))
        setCreatAffliateGroupPermisssion(checkPermission(affliate, "aff_add_affiliate_group"))
        setCreatCommissionGroupPermisssion(checkPermission(affliate, "aff_create_commission_group"))

    }, [affliate])
    useEffect(() => {
        var activepath = []
        if (currentPath === "/affiliate/affliateliste" || currentPath === "/affiliate/add-aff" || currentPath === "/affiliate/affreview" || currentPath === "/affiliate/affreview") {
            activepath = ["2", "2-3"]
        }
        else if (currentPath === "/affiliate/commission-groups" || currentPath === "/affiliate/commission-create-group" || currentPath === "/affiliate/affliate-group/details") {
            activepath = ["2", "2-4"]
        }
        else if (currentPath === "/affiliate/aff-group" || currentPath === "/affiliate/create-aff-group" || currentPath === "/affiliate/commission/details") {
            activepath = ["2", "2-5"]
        }
        else if (currentPath === "/affiliate/summary" || currentPath === "/affiliate/promo-report" || currentPath === "/affiliate/full-report" || currentPath === "/affiliate/player-report") {
            activepath = ["3", "3-1"]
        }
        else if (currentPath === "/affiliate/marketing/campaigns" || currentPath === "/affiliate/marketing/campaign-create") {
            activepath = ["4", "4-1"]
        }
        else if (currentPath === "/affiliate/marketing/add-media" || currentPath === "/affiliate/marketing/list-media") {
            activepath = ["4", "4-2"]
        }
        else if (currentPath === "/affiliate/payment/history" || currentPath === "/affiliate/payment/user-invoices" || currentPath === "/affiliate/payment/user-invoices-status") {
            activepath = ["5", "5-1"]
        }
        else if (currentPath === "/affiliate/settings/create-user" || currentPath === "/affiliate/settings/user-list" || currentPath === "/affiliate/account-settings" || currentPath === "/affiliate/settings/variables" || currentPath === "/affiliate/settings/users/details") {
            activepath = ["6", "6-1"]
        }

        setActive(activepath)
    }, [currentPath])
    const navigateToPage = (link) => {
        nav(link)
        setOpen(false)
    }
    const Logout = () => {
        localStorage.setItem("raff-token", null)
        dispatch({
            type: "SET_USER",
            data: {
                logged: false,
                user: null
            }
        })
        nav("/")
    }
    useEffect(() => {
    }, [active])
    return (
        <>
            {/* Drawer button for mobile view */}
            <Button onClick={() => setOpen(true)} className="d-lg-none" style={{ background: "rgba(0,0,0,.1)", borderRadius: 0, marginRight : 10 }}><i class="fa-solid fa-bars" style={{ color: "#7eac2f", fontSize: 25 }}></i></Button>

            {/* Drawer for mobile view */}
            {open && (
                <>
                    {/* Custom backdrop */}
                    <div
                        className="custom-backdrop"
                        onClick={() => setOpen(false)}
                    ></div>
                    <Drawer open={open} onClose={() => setOpen(false)} placement="left" backdrop={true} style={{ width: "70%", background: "#292d2e", zIndex: 1600 }} onBackdropClick={() => setOpen(false)} className='drawer-affliate'>
                        <Drawer.Body style={{ background: "#292d2e", paddingRight: 5 }} className='drawer-affliate-body'>
                            {/* Copy Navbar links here for mobile */}
                            <div style={{ paddingBottom: 20, textAlign: "center" }}>
                                <img style={{ width: 150 }} src={"/images/logo.png"} alt="Logo" />
                            </div>
                            <Nav className="flex-column" >
                                <Sidenav style={{ background: "#292d2e", color: "#fff" }} defaultOpenKeys={active} >
                                    <Sidenav.Body style={{ background: "#292d2e" }}>
                                        <Nav >

                                            <Nav.Item onClick={() => navigateToPage("/dashboard")} style={{ background: "#292d2e" }} eventKey="1" icon={<DashboardIcon />}>
                                                Main Page
                                            </Nav.Item>
                                            <Nav.Menu style={{ background: "#292d2e" }} eventKey="2" title="Work with Affiliate" icon={<PeopleBranchIcon />}>
                                                <Nav.Item eventKey="2-1" onClick={() => navigateToPage("/affiliate/affliateliste")}>Affiliate List</Nav.Item>
                                                {affliateAddPermission ? (<Nav.Item eventKey="2-2" onClick={() => navigateToPage("/affiliate/add-aff")}>Add Affiliate</Nav.Item>) : (<></>)}
                                                {affliateReviewPermission ? (<Nav.Item eventKey="2-3" onClick={() => navigateToPage("/affiliate/affreview")}>Affiliate review</Nav.Item>) : (<></>)}
                                                <Nav.Menu eventKey="2-4" title="Commission group">
                                                    <Nav.Item eventKey="2-4-1" onClick={() => navigateToPage("/affiliate/commission-groups")}>List Commission group</Nav.Item>
                                                    {createCommissionGroupPermission ? (<Nav.Item eventKey="2-4-2" onClick={() => navigateToPage("/affiliate/commission-create-group")}>Create Commission group </Nav.Item>) : (<></>)}
                                                </Nav.Menu>
                                                <Nav.Menu eventKey="2-5" title="Affiliate group">
                                                    <Nav.Item eventKey="2-5-1" onClick={() => navigateToPage("/affiliate/aff-group")}>List Affiliate group</Nav.Item>
                                                    {createCreatAffliateGroupPermisssion ? (<Nav.Item eventKey="2-5-2" onClick={() => navigateToPage("/affiliate/create-aff-group")}>Create Affliate group </Nav.Item>) : (<></>)}
                                                </Nav.Menu>
                                            </Nav.Menu>
                                            <Nav.Menu style={{ background: "#292d2e" }} eventKey="3" title="Reports" icon={<TrendIcon />}>
                                                <Nav.Item eventKey="3-1" onClick={() => navigateToPage("/affiliate/summary")}>Summary</Nav.Item>
                                                <Nav.Item eventKey="3-2" onClick={() => navigateToPage("/affiliate/full-report")}>Full report</Nav.Item>
                                                <Nav.Item eventKey="3-3" onClick={() => navigateToPage("/affiliate/promo-report")}>Promo material report</Nav.Item>
                                                <Nav.Item eventKey="3-4" onClick={() => navigateToPage("/affiliate/player-report")}>Player report</Nav.Item>
                                            </Nav.Menu>
                                            <Nav.Menu eventKey="4" title="Marketing tools" style={{ background: "#292d2e" }} icon={<MagicIcon />}>
                                                <Nav.Menu eventKey="4-1" title="Campaign">
                                                    <Nav.Item eventKey="4-1-1" onClick={() => navigateToPage("/affiliate/marketing/campaigns")}>List Campaigns</Nav.Item>
                                                    {createCompaignPermission ? (<Nav.Item eventKey="4-2-2" onClick={() => navigateToPage("/affiliate/marketing/campaign-create")}>Create Campaign </Nav.Item>) : (<></>)}
                                                </Nav.Menu>
                                                <Nav.Menu eventKey="4-2" title="Media">
                                                    {mediaAddPermisssion ? (<Nav.Item eventKey="4-2-1" onClick={() => navigateToPage("/affiliate/marketing/add-media")}>Add Media</Nav.Item>) : (<></>)}
                                                    <Nav.Item eventKey="4-2-2" onClick={() => navigateToPage("/affiliate/marketing/list-media")}>List Media </Nav.Item>
                                                </Nav.Menu>
                                            </Nav.Menu>
                                            <Nav.Menu eventKey="5" title="Payments" style={{ background: "#292d2e" }} icon={<CreditCardPlusIcon />}>
                                                <Nav.Item eventKey="5-1" onClick={() => navigateToPage("/affiliate/payment/history")}>Payment history</Nav.Item>
                                                <Nav.Item eventKey="5-2" onClick={() => navigateToPage("/affiliate/payment/user-invoices")}>Affiliate invoices</Nav.Item>
                                                <Nav.Item eventKey="5-3" onClick={() => navigateToPage("/affiliate/payment/user-invoices-status")}>Affiliate invoice status</Nav.Item>
                                            </Nav.Menu>
                                            <Nav.Menu eventKey="6" title="Settings" style={{ background: "#292d2e" }} icon={<MemberIcon />}>
                                                <Nav.Item eventKey="6-1" onClick={() => navigateToPage("/affiliate/account-settings")}>Account settings</Nav.Item>
                                                {userCreatePermisssion ? (<Nav.Item eventKey="6-2" onClick={() => navigateToPage("/affiliate/settings/create-user")}>Create user</Nav.Item>) : (<></>)}
                                                <Nav.Item eventKey="6-3" onClick={() => navigateToPage("/affiliate/settings/user-list")}>User list</Nav.Item>
                                                <Nav.Item eventKey="6-4" onClick={() => navigateToPage("/affiliate/settings/mailing-templates")}>Mailing Templates</Nav.Item>
                                                {
                                                    userx.User != null && userx.User.Permissions == null ? (
                                                        <Nav.Item eventKey="6-5" onClick={() => navigateToPage("/affiliate/settings/variables")}>Affiliate Variables</Nav.Item>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </Nav.Menu>
                                            <Nav.Item onClick={() => Logout()} style={{ background: "#292d2e" }} eventKey="7" icon={<PeoplesUploadedIcon />}>
                                                Logout
                                            </Nav.Item>
                                        </Nav>
                                    </Sidenav.Body>
                                </Sidenav>
                            </Nav>
                        </Drawer.Body>
                    </Drawer>
                </>
            )}
        </>)
}